﻿import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

import { useT } from "@/lib/i18n";
import { cn } from "@/lib/utils";

interface PageHeaderProps {
  title: string;
  description?: string;
  backHref?: string;
  backLabel?: string;
  children?: React.ReactNode;
  className?: string;
}

/**
 * Sayfa başlığı + opsiyonel geri butonu + sağ tarafta action slot.
 * Mobile'da action'lar alta sarar, desktop'ta aynı satıra.
 */
export function PageHeader({
  title,
  description,
  backHref,
  backLabel,
  children,
  className,
}: PageHeaderProps) {
  const tCommon = useT("common");
  return (
    <div className={cn("mb-6 space-y-3 sm:mb-8", className)}>
      {backHref ? (
        <Link
          to={backHref}
          className="-ms-1 inline-flex items-center gap-1 rounded-md px-1.5 py-1 text-sm text-muted-foreground transition-colors hover:bg-accent hover:text-foreground"
        >
          <ChevronLeft className="h-4 w-4 rtl:-scale-x-100" />
          {backLabel ?? tCommon("back")}
        </Link>
      ) : null}
      <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
        <div className="min-w-0">
          <h1 className="text-2xl font-semibold tracking-tight sm:text-3xl">
            {title}
          </h1>
          {description ? (
            <p className="mt-1 max-w-2xl text-sm text-muted-foreground">
              {description}
            </p>
          ) : null}
        </div>
        {children ? (
          <div className="flex shrink-0 flex-wrap items-center gap-2">
            {children}
          </div>
        ) : null}
      </div>
    </div>
  );
}
